const state = {
    depmessage: '' 
}
const mutations = {
    changeMsg (state, val) {
        state.depmessage = val
    }
}

export default {
    state,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/message.js